import axios from '../axios';

const fetchFlowNodes = async (flowId: string) => {
  const { data } = await axios.get(`/flows/${flowId}/nodes`);

  return data;
};

export default fetchFlowNodes;
